export function useWindowResize() {
	const width = ref(window.innerWidth);
	const height = ref(window.innerHeight);

	function onResize() {
		width.value = window.innerWidth;
		height.value = window.innerHeight;
	}

	const isMobile = computed(() => {
		if (!window) {
			return false;
		}
		return width.value <= SCREEN_SIZE.MOBILE;
	});

	const isTablet = computed(() => {
		if (!window) {
			return false;
		}
		return width.value <= SCREEN_SIZE.TABLET;
	});

	watch(() => window, () => {
		width.value = window.innerWidth;
		height.value = window.innerHeight;
	});

	// Add resize event listener when the component is mounted
	onMounted(() => {
		window.addEventListener('resize', onResize);
	});

	// Remove the event listener when the component is unmounted
	onUnmounted(() => {
		window.removeEventListener('resize', onResize);
	});

	return {
		width,
		height,
		isMobile,
		isTablet,
	};
}
